module.exports = __webpack_public_path__ + "img/111.68255b32.jpg";